import React, {useContext, useEffect} from 'react';
import SourceBlock from './SourceBlock';
import SocialFilters from './EntityFilters/SocialFilters';
import {Input} from 'reactstrap';
import {EntityContext} from 'contexts/EntityContext';

const ArticleListBySource = (props) => {
    const {
        activeEntitySort, entitySocialFilters, activeEntity,
        entitySocialCount, updatingEntityCount, entitiesLoading,
    } = useContext(EntityContext);

    const {
        searchResults, socialFilters, sentimentFilters, activeEntityId, handleEntitySortChange,
        setEntityNews, toggleSocialFilters
    } = props;

    return (
        <div className="home-page-article-list mt-0 h-100" style={{minHeight: '100px'}}>
            {/*<div className="mt-4 d-flex align-items-center justify-content-end">*/}
            {/*    {activeEntity && activeEntity.settings && Object.keys(activeEntity.settings.sources).filter((key) => activeEntity.settings.sources[key] !== null).length > 0 &&*/}
            {/*    <div className="ml-3">*/}
            {/*        <SocialFilters*/}
            {/*            socialFilters={entitySocialFilters}*/}
            {/*            toggleSocialFilters={toggleSocialFilters}*/}
            {/*            activeView="entities"*/}
            {/*            updating={entitiesLoading || updatingEntityCount}*/}
            {/*            socialCount={entitySocialCount}*/}
            {/*            activeEntity={activeEntity}*/}
            {/*            inHeader*/}
            {/*            hideLabel*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*    }*/}
            {/*    <div*/}
            {/*        className="home-page-filters__filter-container d-flex justify-content-between align-items-center ml-5">*/}
            {/*        <Input className="home-page-filters__sort-dropdown"*/}
            {/*               onChange={(e) => handleEntitySortChange(e.target.value)}*/}
            {/*               value={activeEntitySort} type="select" name="sorting">*/}
            {/*            <option value={0}>Date (Newest to Oldest)</option>*/}
            {/*            <option value={1}>Date (Oldest to Newest)</option>*/}
            {/*            <option value={2}>Source</option>*/}
            {/*        </Input>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div style={{minHeight: '100px'}}>
            {searchResults && searchResults.map(sourceBlock => {
                return (socialFilters[sourceBlock.type] === true) && (
                    <SourceBlock source={sourceBlock} activeEntityId={activeEntityId}
                                 key={`block-${sourceBlock.id}`}
                                 sentimentFilters={sentimentFilters} fullSearchResults={searchResults}
                                 setEntityNews={setEntityNews}
                    />
                );
            })}
            </div>
        </div>
    );
};

export default ArticleListBySource;
